'use client';

import useDevice from '@/hooks/useDevice';
import "@/styles/sections/sections.scss";
import { ItemProps } from '@/constants/beforeafter';
import { BEFORE_ITEMS, AFTER_ITEMS } from '@/constants/beforeafter';
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { BoxIcon, MailBoxIcon, ChartIcon, ChatIcon } from './BeforeAfterIcons';

const ItemCard = ({ Icon, title, description, highlight = false, highlightText = '' }: ItemProps) => (
    <div className='item'>
        <Icon highlight={highlight} />

        <div className='item-content'>
            <p className='title'>
                {highlightText
                    ? title.split(highlightText).map((part, index, array) => (
                        <React.Fragment key={index}>
                            {part}
                            {index < array.length - 1 && <span className='highlight'>{highlightText}</span>}
                        </React.Fragment>
                    ))
                    : title
                }
            </p>
            <p className='description'>{description}</p>
        </div>
    </div>
);

const BeforeAfterSection = () => {
    const { t } = useLanguage();

    const icons = [BoxIcon, ChatIcon, ChartIcon, MailBoxIcon];
    
    const beforeItems = t.beforeafter.beforeItems.map((item, index) => ({
        ...item,
        Icon: icons[index],
        highlight: false
    }));
    
    const afterItems = t.beforeafter.afterItems.map((item, index) => ({
        ...item,
        Icon: icons[index],
        highlight: true
    }));

    return (
        <div className="beforeafter-section">
            <div className='before-container'>
                <p className='title'>{t.beforeafter.beforeTitle}</p>
                <div className='item-container'>
                    {beforeItems.map((item, index) => (
                        <ItemCard key={index} {...item} />
                    ))}
                </div>
            </div>

            <div className='after-container'>
                <p className='head-title'>{t.beforeafter.afterTitle}</p>
                <div className='item-container'>
                    {afterItems.map((item, index) => (
                        <ItemCard key={index} {...item} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BeforeAfterSection;